import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { SwatchComponent } from '../../../attribute/swatch/swatch.component';
import { Product } from '../../product.decorator';
import { ProductViewSamplesComponent } from '../../view-samples/product-view-samples.component';
@Component({
    selector: 'product-view-crosssell-products-color',
    templateUrl: '/product-view-crosssell-products-color.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [SwatchComponent, CommonModule, HrefComponent, ProductViewSamplesComponent, TranslationModule, IfSizeDirective]
})
export class ProductViewCrosssellProductsColorComponent implements OnChanges {
    @Input()
    product?: Product<IProductDataV3>;
    options: Product<IProductDataV3>[] = [];
    @Input()
    upsellVariant: boolean = false;
    @Input()
    isHuge = true;
    @Output()
    productClick = new EventEmitter<Product<IProductDataV3>>();
    ngOnChanges(): void {
        this.options = this.getOptions();
    }
    trackByProductId(index: number, product: Product): number {
        return product.id;
    }
    private getOptions(): Product<IProductDataV3>[] {
        if (this.product?.hasColorCrosssells) {
            const crossSellProducts = this.product.colorCrossSellProducts;
            if (crossSellProducts?.length) {
                return [...crossSellProducts];
            }
        }
        return [];
    }
}
